import Vue from 'vue'
import Axios from 'axios'

function load() {
    Axios({
        method: 'get',
        url: '/backend.json',

    }).then(res => {
       
       
        const currentURL = window.location.href;
        if (currentURL.includes('.cn')) {
            // 在包含 .cn 的情况下执行的操作
            console.log('URL contains .cn');
            Vue.prototype.$backend.host = res.data.host

            // 进行其他操作
            Vue.prototype.$backend.wpHost = res.data.wpHost
        } else if (currentURL.includes('.com')) {
            // 在包含 .com 的情况下执行的操作
            console.log('URL contains .com');
            Vue.prototype.$backend.host = res.data.hostEn

            // 进行其他操作
            Vue.prototype.$backend.wpHost = res.data.wpHostEn
        }  else {
            // URL 既不包含 .com 也不包含 .cn 的情况下执行的操作
            console.log('URL does not contain .com or .cn');
            // 进行其他操作
            let preferredLang =
                localStorage.getItem("preferredLang") ||
                navigator.language ||
                navigator.userLanguage ||
                navigator.browserLanguage ||
                "en";
            
            Vue.prototype.$backend.host = preferredLang == 'en' ? res.data.hostEn : res.data.host
            Vue.prototype.$backend.wpHost = preferredLang == 'en' ? res.data.wpHostEn : res.data.wpHost
        }

        Vue.prototype.$backend.isReady = true
    })
}

load()

Vue.prototype.$backend = {
    isReady: false,
    host: '',
    articleHost: '',
    pictureHost: ''
}